import axios from "axios";
import Cookies from "js-cookie";

// Single transport boundary to the PHP+MySQL backend (the real server).
// Every API call goes through here → one place knows the protocol + base URL.
// Override per environment with REACT_APP_API_BASE (e.g. a local PHP in .env.local).
export const API_BASE = process.env.REACT_APP_API_BASE || "https://hostess.lega6.com/php";
const ENDPOINT = `${API_BASE}/index.php`;

// PHP "OK" statuses are 100–149 (see php/security.php statusList).
export const isOk = (envelope) => {
    const code = Number(envelope?.debug?.statusCode);
    return code >= 100 && code < 150;
};
export const statusOf = (envelope) => Number(envelope?.debug?.statusCode);
export const statusText = (envelope) => envelope?.debug?.statusText || "";

// Call one PHP "act". Wraps the request in the backend envelope and injects the
// stored token + business token. Returns the full PHP body { debug:{...}, data:{...} }.
export async function callAct(act, data = {}, extraAuth = {}) {
    const authentication = {
        key: Cookies.get("authToken") || "",
        businessToken: Cookies.get("busiToken") || "",
        ...extraAuth,
    };
    const res = await axios.post(ENDPOINT, { authentication, data, type: { act } });
    return res.data;
}

export default { API_BASE, callAct, isOk, statusOf, statusText };
